module.exports = __webpack_public_path__ + "img/879a376a930d1109.png";